var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"youtube-embed"},[_c('youtube',{ref:`video${_vm.video.id}`,attrs:{"video-id":_vm.video.id},on:{"ready":_vm.ready,"ended":function($event){return _vm.$emit('end')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }